import { useTranslation } from 'next-i18next'
import React from 'react'

import Product from '@src/quince-site-common/src/domains/Product'
import { IProductPurchaseInfo } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ISubscribedPlan, ISubscriptionPlan } from '@src/quince-site-common/src/domains/Subscription'

import { CTA_TYPE } from '../../productCTA/productCTAConstants'
import ProductSubscriptionDeliveryMessage from '../../productSubscriptionDeliveryMessage'
import { PurchaseType, PurchaseTypeSelector, PurchaseTypeSelectorShimmer } from '../../purchaseTypeSelector'

export interface ProductFormSubscriptionPurchaseSectionProps {
  showProductSubscriptionDeliveryMessage: boolean
  subscribedPlan: ISubscribedPlan | undefined
  showNewPdpDesignV2?: boolean
  selectedVariantPurchaseInfoShowWaitList: boolean | undefined
  productCTAType: CTA_TYPE
  isRecurringItemSubscriptionsExpEnabled: boolean
  hidePurchaseTypeSelector?: boolean
  subscriptionEnabled: boolean | undefined
  productPurchaseInfo: IProductPurchaseInfo | undefined
  showPurchaseTypeSelector: boolean
  product: Product | undefined
  purchaseOption: PurchaseType
  setPurchaseOption: (purchaseOption: PurchaseType) => void
  selectedPlanId: number | undefined
  setSelectedPlanId: (selectedPlanId: number | undefined) => void
  isFromCartPopup?: boolean
  isBuyNow?: boolean
  variantSubscriptionPlans: ISubscriptionPlan[]
  formattedSubscriptionPrice: string | undefined
  formattedSalePrice: string
  formattedFestivalOfferPrice?: string
  subscriptionFestivalSavingPercentage?: number
  subscriptionId: string | undefined
  showVariantAvailableInventory: boolean
  selectedVariantAvailableInventory: number
  isQuickATCForMobile?: boolean
}

export function ProductFormSubscriptionPurchaseSection(props: ProductFormSubscriptionPurchaseSectionProps) {
  const { t } = useTranslation()
  const isFromPdp = !props.isFromCartPopup && !props.isBuyNow
  const isInStock =
    !props.selectedVariantPurchaseInfoShowWaitList &&
    ![CTA_TYPE.OUT_OF_STOCK, CTA_TYPE.PREORDER, CTA_TYPE.WAITLIST].includes(props.productCTAType)

  return (
    <>
      {props.showProductSubscriptionDeliveryMessage && (
        <ProductSubscriptionDeliveryMessage
          subscribedPlan={props.subscribedPlan as ISubscribedPlan}
          showNewPdpDesignV2={props.showNewPdpDesignV2 ?? false}
          isInStock={isInStock}
        />
      )}
      {/* Purchase Type Selector: lets users choose Subscribe or One-time purchase.
          Shimmer shows while productPurchaseInfo is loading (active-inventory API). Subscriptions are hidden for OOS variants. */}
      <PurchaseTypeSelectorShimmer
        isFromPdp={isFromPdp}
        showNewPdpDesignV2={Boolean(props.showNewPdpDesignV2)}
        showShimmer={Boolean(
          props.isRecurringItemSubscriptionsExpEnabled &&
          !props.hidePurchaseTypeSelector &&
          props.subscriptionEnabled &&
          !props.productPurchaseInfo,
        )}
      >
        {!props.showPurchaseTypeSelector ? null : (
          <PurchaseTypeSelector
            product={props.product as Product}
            value={props.purchaseOption}
            onChange={props.setPurchaseOption}
            selectedPlanId={props.selectedPlanId}
            onPlanIdChange={props.setSelectedPlanId}
            subscribeLabel={t('subscribe')}
            oneTimeLabel={t('one_time_purchase')}
            name={
              props.isFromCartPopup ? 'cartPurchaseType' : props.isBuyNow ? 'buyNowPurchaseType' : 'pdpPurchaseType'
            }
            variantSubscriptionPlans={props.variantSubscriptionPlans}
            formattedSubscriptionPrice={props.formattedSubscriptionPrice as string}
            formattedSalePrice={props.formattedSalePrice}
            formattedFestivalOfferPrice={props.formattedFestivalOfferPrice}
            subscriptionFestivalSavingPercentage={props.subscriptionFestivalSavingPercentage}
            isFromPdp={isFromPdp}
            showNewPdpDesignV2={props.showNewPdpDesignV2}
            subscriptionId={props.subscriptionId}
          />
        )}
      </PurchaseTypeSelectorShimmer>
    </>
  )
}
